import { DateTime } from 'luxon';
import { DateZone } from '@oai-frontend-monorepo/types';

export const decideLatestDateForHistory = (
  date: DateTime = DateTime.utc().setZone(DateZone.New_York)
) => {
  while (date.weekday > 5) {
    date = date.minus({ days: 1 });
  }

  return date.hour < 9 || (date.hour === 9 && date.minute < 30)
    ? date.minus({ days: 1 })
    : date;
};
